import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'lib-bw-svc-apis/src/lib/storage/storage.service';
import { HttpService } from 'lib-bw-svc-apis/src/lib/http/http.service';
import { LoaderService } from 'lib-bw-svc-apis/src/lib/loader/loader.service';
import { Store } from '@ngrx/store';
import * as FeatureFlagsActions from '../../../lib-bw-svc-apis/src/lib/featureFlags/feature-flags.actions';
import { SessionPopupService } from 'lib-bw-svc-apis/src/lib/session-expiry/session-popup.service';
import { LoginService } from 'lib-bw-svc-apis/src/lib/login/login.service';
import { OutlookService } from 'lib-bw-svc-apis/src/lib/outlook/outlook.service';
import { FeatureFlagsService } from 'lib-bw-svc-apis/src/lib/featureFlags/featureFlags.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  public showLoader: boolean = false;
  public showSessionExpiryPopup: boolean = false;
  public showSessionExpiringTimerPopup: boolean = false;
  public isIdleTimeOutEnabled: boolean = false;
  public timeLeft: string = '00:00';
  public timer: any;

  constructor(
    private http: HttpService,
    private loaderService: LoaderService,
    private loginService: LoginService,
    private session: StorageService,
    private outlookService: OutlookService,
    private route: Router,
    private store: Store,
    private sessionPopup: SessionPopupService,
    private FFservc: FeatureFlagsService
  ) {
    this.getToken();
  }

  ngOnInit(): void {
    this.listenToSessionExpiry();
    this.listenToSessionExpiryWarning();
    if (window.location.href.includes('aiAction=open') && (window.location.href.includes('/admin/documents') || window.location.href.includes('/admin/meetings'))) {
      this.session.setData('aiDeepLinkUrl', window.location.href);
    }
  }

  ngAfterViewInit(): void {
    this.loaderService.isLoading.subscribe((res: boolean) => {
      // Prevent https://v17.angular.io/errors/NG0100
      setTimeout(() => {
        this.showLoader = res;
      }, 200);
    });

    const currentUrl = this.route.url;
    if (currentUrl.includes('login')) {
      this.showSessionExpiryPopup = false;
      this.showSessionExpiringTimerPopup = false;
    }
  }

  listenToSessionExpiry(): void {
    this.sessionPopup.popupState$ // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe(show => {
        const currentUrl = this.route.url;
        if (currentUrl.includes('login')) {
          this.showSessionExpiryPopup = false;
          this.showSessionExpiringTimerPopup = false;
          return;
        } else {
          this.showSessionExpiringTimerPopup = false;
          this.showSessionExpiryPopup = show;
          if (show) {
            const presentUrl = window.location.href;

            let screenData = {
              url: presentUrl,
              rolePermission: this.session.getData('rolePermission'),
              userPermission: this.session.getData('userPermission'),
              userId: this.session.getData('userId'),
              boardId: this.session.getData('loggedInBoard')
            };

            // let lastCaptured = this.session.getData('lastCapturedScreen');
            this.session.removeAllData();
            this.outlookService.clearQueryParams();

            this.session.setData('lastCapturedScreen', JSON.stringify(screenData));

            this.http.getTokenAppAsync();
          }
        }
      });
  }

  listenToSessionExpiryWarning(): void {
    this.sessionPopup.popupWarningState$.subscribe(show => {
      const currentUrl = this.route.url;
      if (currentUrl.includes('login')) {
        this.showSessionExpiryPopup = false;
        this.showSessionExpiringTimerPopup = false;
        clearInterval(this.timer);
        return;
      } else {
        clearInterval(this.timer);
        this.showSessionExpiringTimerPopup = show;
        this.startCountdown();
      }
    });
  }

  startCountdown() {
    if (this.timer) clearInterval(this.timer);

    let current = 5; // start from 5 minutes
    this.timeLeft = current.toString();

    this.timer = setInterval(() => {
      current--; // decrement by 1 minute

      if (current <= 1) {
        this.timeLeft = '1';
        return;
      }

      this.timeLeft = current.toString();
    }, 60 * 1000); // 1 minute interval
  }

  saveModalAction() {
    window.location.reload();
  }

  async getToken() {
    const isLoggedIn = this.session.getData('isLoggedIn');
    let requestedData: any;

    if (isLoggedIn) {
      this.session.setData('requestedUrl', window.location.pathname);
      requestedData = this.session.bindParamsForSessionSharing();
    }

    const token = await this.http.getTokenAppAsync();

    if (token) {
      this.store.dispatch(FeatureFlagsActions.loadFeatureFlags());
      await this.FFservc.loadIdleTimeOutFlag();
    }

    this.isIdleTimeOutEnabled = this.FFservc.isEnabled_IdleTimeOut();

    if (token && isLoggedIn) {
      this.session.setDataToSessionStorage();

      if (requestedData.params) {
        this.route.navigate([requestedData.url, requestedData.params], {
          queryParams: requestedData.queryParams
        });
      } else {
        this.route.navigate([requestedData.url], {
          queryParams: requestedData.queryParams
        });
      }
    }
  }

  async onCancelClick(): Promise<void> {
    this.showSessionExpiringTimerPopup = false;
    await this.logout();
  }

  stayLoggedInClick(): void {
    this.loginService.getBoards().subscribe(res => {
      if (res && res.result) {
        this.showSessionExpiringTimerPopup = false;
      }
    });
  }

  async onCancelClickForLogin() {
    this.showSessionExpiryPopup = false;
    this.route.navigate(['/login'], { queryParams: { redirectToPreviousScreen: true } });
  }

  async logout(shouldRedirectBack: boolean = false) {
    this.showSessionExpiryPopup = false;
    const presentUrl = window.location.href;

    let screenData = {
      url: presentUrl,
      rolePermission: this.session.getData('rolePermission'),
      userPermission: this.session.getData('userPermission'),
      userId: this.session.getData('userId'),
      boardId: this.session.getData('loggedInBoard')
    };

    this.loginService.logout().subscribe(
      async res => {
        if (res.result) {
          let lastCaptured = this.session.getData('lastCapturedScreen');
          this.session.removeAllData();
          this.outlookService.clearQueryParams();
          if (!lastCaptured) {
            this.session.setData('lastCapturedScreen', JSON.stringify(screenData));
          } else {
            this.session.setData('lastCapturedScreen', lastCaptured);
          }

          let redirectionRequired = shouldRedirectBack ? { redirectToPreviousScreen: true } : {};
          this.route.navigate(['/login'], {
            queryParams: redirectionRequired
          });

          await this.http.getTokenAppAsync();
        }
      },
      async err => {
        this.showSessionExpiryPopup = false;
        let lastCaptured = this.session.getData('lastCapturedScreen');

        this.session.removeAllData();

        if (!lastCaptured) {
          this.session.setData('lastCapturedScreen', JSON.stringify(screenData));
        } else {
          this.session.setData('lastCapturedScreen', lastCaptured);
        }
        this.route.navigate(['/login']);
        await this.http.getTokenAppAsync();
      }
    );
  }
}

